import React,{useState} from 'react'

export default function TextForm(props) {
    const handleUpClick  = ()=>{
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Converted to UpperCase","success");
    }
    const handleLoClick  = ()=>{
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted to LowerCase","success");
    }
    const handleClearTextClick  = ()=>{
        setText('');
        props.showAlert("Text Cleared","success");
    }
    const handleCopyTextClick  = ()=>{
        navigator.clipboard.writeText(text);
        props.showAlert("Text Copied","success");
    }
    const handleRemoveExtraSpacesClick  = ()=>{
        setText(text.split(/[ ]+/).join(" "));
    }
    const handleOnChange  = (event)=>{
        setText(event.target.value);
    }
    const [text,setText] = useState('');
    // text = "new Text"; //Wrong way to set the text
    // setText("new Text"); //Correct way to set the text
return (
    <>
    <div className='conatiner' style={{color: props.mode==='dark'?'white':'#042743'}}>
    <h1>{props.heading}</h1>
    <div className="mb-3">
        {/* <label for="myBox" class="form-label">Example textarea</label> */}
            <textarea className="form-control" id="myBox" rows="8" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'grey':'white',color:props.mode==='dark'?'white':'#042743'}}></textarea>
    </div>
    <button className='btn btn-primary mx-2' onClick={handleUpClick}>Convert to UpperCase</button>
    <button className='btn btn-primary mx-2' onClick={handleLoClick}>Convert to LowerCase</button>
    <button className='btn btn-primary mx-2' onClick={handleClearTextClick}>Clear Text</button>
    <button className='btn btn-primary mx-2' onClick={handleCopyTextClick}>Copy Text</button>
    <button className='btn btn-primary mx-2' onClick={handleRemoveExtraSpacesClick}>Remove Extra Spaces</button>
    </div>
    <div className='conatiner my-3' style={{color: props.mode==='dark'?'white':'#042743'}}>
        <h2>Your Text Summary</h2>
        <p>{text.trim() === '' ? 0 : text.match(/\S+/g).length} words and {text.replace(/\s+/g, '').length} characters</p>
        <p>{0.008 * (text.trim() === '' ? 0 : text.match(/\S+/g).length)} is the time to read this</p>
        <h2>Preview</h2>
        <p>{text===''?'Enter Something to Preview':text}</p>
    </div>
    </>
)
}